
import { useState, useEffect } from 'react';
import { useLocation, useNavigate, NavigateFunction } from 'react-router-dom';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string, navigate: NavigateFunction) => {
    if (window.location.pathname === '/') {
      // 같은 페이지에 있을 때
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // 다른 페이지에 있을 때
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleLogoClick = () => {
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <button
            onClick={handleLogoClick}
            className="text-3xl font-bold text-black hover:text-gray-700 transition-colors cursor-pointer"
          >
            Prime Connect
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8">
            <button
              onClick={() => scrollToSection('about', navigate)}
              className="text-base font-medium text-gray-800 hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('brand-partners', navigate)}
              className="text-base font-medium text-gray-800 hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Brand
            </button>
            <button
              onClick={() => scrollToSection('what-we-do', navigate)}
              className="text-base font-medium text-gray-800 hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Service
            </button>
            <button
              onClick={() => scrollToSection('contact-section', navigate)}
              className="text-base font-medium text-gray-800 hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-2xl text-black cursor-pointer"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3">
            <button
              onClick={() => scrollToSection('about', navigate)}
              className="block w-full text-left text-base font-medium text-gray-800 hover:text-gray-600 transition-colors cursor-pointer py-2"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('brand-partners', navigate)}
              className="block w-full text-left text-base font-medium text-gray-800 hover:text-gray-600 transition-colors cursor-pointer py-2"
            >
              Brand
            </button>
            <button
              onClick={() => scrollToSection('what-we-do', navigate)}
              className="block w-full text-left text-base font-medium text-gray-800 hover:text-gray-600 transition-colors cursor-pointer py-2"
            >
              Service
            </button>
            <button
              onClick={() => scrollToSection('contact-section', navigate)}
              className="block w-full text-left px-6 py-2.5 bg-black text-white rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
